import { render, staticRenderFns } from "./CmpFgDetail.vue?vue&type=template&id=732b4f90&scoped=true&"
import script from "./CmpFgDetail.vue?vue&type=script&lang=js&"
export * from "./CmpFgDetail.vue?vue&type=script&lang=js&"
import style0 from "./CmpFgDetail.vue?vue&type=style&index=0&id=732b4f90&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732b4f90",
  null
  
)

export default component.exports